"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const inversify_1 = require("inversify");
const constants_1 = require("./constants");
const queryBuild_1 = __importDefault(require("../../helpers/url/queryBuild"));
require("reflect-metadata");
const merge_1 = __importDefault(require("lodash/merge"));
const interceptor_before_reject_1 = require("./interceptors/interceptor-before-reject");
const interceptor_1 = require("./interceptor");
let NetworkService = class NetworkService {
    constructor(globalConfig = null) {
        this.globalConfig = globalConfig;
        this.buildBaseUrl = (baseUrl) => {
            if (this.lang === process.env.LANG_DEFAULT) {
                return baseUrl;
            }
            return `/${this.lang}${baseUrl}`;
        };
        this.initAxiosInstances();
    }
    setLang(lang) {
        this.lang = lang;
        this.initAxiosInstances();
    }
    createCancelTokenSource() {
        return axios_1.default.CancelToken.source();
    }
    getSimple(url, config) {
        return this.axiosInstanceSimple.get(url, config);
    }
    postSimple(url, data, config) {
        return this.axiosInstanceSimple.post(url, data, config);
    }
    get(url, config) {
        return this.axiosInstance.get(url, config);
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    initAxiosInstances() {
        this.axiosInstance = this.initAxiosInstance();
        this.axiosInstanceSimple = this.initAxiosInstanceSimple();
    }
    initAxiosInstance() {
        const config = this.buildInstanceConfig({
            baseURL: this.buildBaseUrl(constants_1.URL_BASE),
        });
        const axiosInstance = axios_1.default.create(config);
        axiosInstance.interceptors.request.use((config) => {
            const newConfig = Object.assign({}, config);
            newConfig.paramsSerializer = (params) => (0, queryBuild_1.default)(params);
            return newConfig;
        });
        (0, interceptor_1.addInterceptor)(axiosInstance);
        return axiosInstance;
    }
    initAxiosInstanceSimple() {
        const config = this.buildInstanceConfig({
            baseURL: this.buildBaseUrl('/'),
        });
        const axiosInstanceSimple = axios_1.default.create(config);
        // noinspection TypeScriptValidateTypes
        axiosInstanceSimple.interceptors.response.use(
        // @ts-ignore
        (response) => ({
            xhr: response.request,
            status: true,
            statusCode: response.status,
            data: response.data,
        }), interceptor_before_reject_1.interceptorBeforeReject);
        return axiosInstanceSimple;
    }
    buildInstanceConfig(config) {
        let configNew = {};
        if (this.globalConfig) {
            configNew = (0, merge_1.default)(configNew, this.globalConfig);
        }
        configNew = (0, merge_1.default)(configNew, config);
        return configNew;
    }
};
NetworkService = __decorate([
    (0, inversify_1.injectable)()
], NetworkService);
exports.default = NetworkService;
